import { message } from "antd";
import axios from "axios";

// 答案解析网自己的 api
export const laravelAxios = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
});

laravelAxios.interceptors.request.use((config) => {
  config.headers = {
    "Content-Type": "application/json",
    "X-Requested-With": "XMLHttpRequest",
    Authorization: `Bearer ${localStorage.token}`,
    ...config.headers,
  };

  // GET 请求，如果没有 data 值，axios 不会添加 Content-Type header
  if (config.method === "get" && !config.data) {
    config.data = {};
  }

  return config;
});

laravelAxios.interceptors.response.use(
  (response) => {
    const {
      data,
      config: {
        errMsg = true, // 错误提示信息（用于覆盖接口返回的提示信息）
        successMsg = false, // 成功提示信息（用于覆盖接口返回的提示信息）
        meta = false, // 是否返回完整响应体（用于需要自己判断成功失败的情况）
      },
    } = response;
    // 返回完整响应体
    if (meta) {
      return data;
    }

    if (data.code !== 0) {
      if (errMsg) {
        message.error(typeof errMsg === "string" ? errMsg : data.msg || "系统繁忙");
      }
      throw new Error(data.msg);
    }

    if (successMsg) {
      message.success(typeof successMsg === "string" ? successMsg : data.msg || "操作成功");
    }

    return data.data;
  },
  (err) => {
    // 登录态校验失败
    if (err?.response?.status == 401) {
      message.destroy();
      message.error("登录态已过期，请重新登录");
      delete localStorage.token;
      window.history.replaceState({ page: history.state }, "", '#/login');
      window.location.replace("#/login");
      return;
    }
    !err?.response?.config?.errMsg
      ? message.info(`网络异常（${err?.response?.status}）`)
      : "";
    throw new Error(err);
  }
);
